import { isClient } from './application_helper';

export default class WindowHelper {
  static open(url, target) {
    if (isClient()) {
      if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
        // if safari
        window.open(url, target);
      } else if (!window.navigator.userAgent.match(/iPhone|iPad/i) && !window.navigator.userAgent.match(/Chrome/i)) {
        window.location.href = url;
      } else {
        window.open(url, target);
      }
    }
  }

  static openFile(filePromise) {
    window.URL = window.URL || window.webkitURL;
    let newWindow = window.open('/download');
    newWindow.onload = () => {
      filePromise.then((file) => {
        newWindow.location = window.URL.createObjectURL(file);
      });
    };
  }

  static goToFile(file, filename) {
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(file, filename + '.pdf');
    } else {
      window.location = window.URL.createObjectURL(file);
    }
  }

  /* eslint-disable no-alert */
  static confirm(message) {
    return isClient() && window.confirm(message);
  }

  static alert(message) {
    if (isClient()) {
      window.alert(message);
    }
  }

  static goTo(url) {
    window.location.replace(url);
  }
  /* eslint-enable no-alert */
}
